/**
 * The Eingänge opened straight from a mail let go on the start page and not
 * shown yet (final review M-7).
 *
 * Only that first showing ticks the drawings already on the Vorgang: dropped
 * beside the mail, they are there to be read. Opened again — back from the
 * reading, after a reload, later from the history — they are on file and,
 * as a rule, read already; ticked, the next press would read them a second
 * time by accident. Attachments of the mail not adopted yet keep their own
 * preselection either way.
 *
 * Memory of this tab only, on purpose: a reload is a reopening. The start
 * page marks the arrival before it navigates; the Eingang reads the mark
 * when it first shows and spends it once it stands (`forgetArrival` in an
 * effect — reading it is free of side effects, so a render run twice reads
 * it twice the same).
 */
const arrivals = new Set<string>();

function keyOf(caseId: string, entryId: string): string {
  return `${caseId}:${entryId}`;
}

/** The start page is about to open this mail's Eingang for the first time. */
export function markArrival(caseId: string, entryId: string): void {
  arrivals.add(keyOf(caseId, entryId));
}

/** Whether this showing of the Eingang is the arrival from the start page. */
export function isArrival(caseId: string, entryId: string): boolean {
  return arrivals.has(keyOf(caseId, entryId));
}

/** The arrival is shown: every later showing is a reopening. */
export function forgetArrival(caseId: string, entryId: string): void {
  arrivals.delete(keyOf(caseId, entryId));
}
